module.exports = __webpack_public_path__ + "media/warranty-claim/photos-fasteners4-25c110ca.png";